export default __webpack_public_path__ + "static/media/image 6.5c0d4c51.svg";